import { FC } from 'react';
import styles from './AsyncTaskError.scss';
import { recordDisplayDate } from './utils/recordDisplay';
import { split } from 'lodash';
import { Close } from 'jbc-front/components/icons';
import { useAsyncTask, TaskType } from './AsyncTask';

const title = {
  send_request: 'ストレスチェックの送信でエラー',
  resend_request: '受検勧奨メールの送信でエラー',
  health_checkup_institution_csv_import: '健康診断実施機関インポートエラー',
  regular_health_checkup_result_csv_import: '定期健康診断 個人結果の一括更新でエラー'
};

const partialSuccessNoticeMap = {
  health_checkup_institution_csv_import: 'なお、以下にエラー表示のない健康診断実施機関は、正常に登録されています。',
  regular_health_checkup_result_csv_import: 'なお、以下にエラー表示のない個人結果は、正常に登録されています。'
};

interface AsyncTaskErrorProps {
  displayTypes?: TaskType[];
}

export const AsyncTaskError: FC<AsyncTaskErrorProps> = ({ displayTypes }) => {
  const { task, confirm } = useAsyncTask();

  if (!task || !['failed', 'partial_success'].includes(task.status)) return null;
  if (displayTypes && !displayTypes.includes(task.taskType)) return null;

  const partialSuccessNotice = task.status === 'partial_success' ? partialSuccessNoticeMap[task.taskType] : '';

  return task && (task.status === 'failed' || 'partial_success') ? (
    <div className={styles.errorWrap}>
      <div onClick={confirm} className={styles.close} role="presentation">
        <Close size={20} />
      </div>
      <div className={styles.inner}>
        <p className={styles.title}>
          {title[task.taskType]}
          が発生しました。
          {partialSuccessNotice}
        </p>
        <div className={styles.dates}>
          <dl>
            <dt>開始日時：</dt>
            <dd>{recordDisplayDate(task.excutedAt, 'LLL')}</dd>
          </dl>
          <dl>
            <dt>エラー日時：</dt>
            <dd>{recordDisplayDate(task.endedAt, 'LLL')}</dd>
          </dl>
        </div>
        <ul className={styles.list}>
          {split(task.error, '\n').map((error, idx) => (
            <li key={idx}>{error}</li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
};

export default AsyncTaskError;
